import styled from 'styled-components';
import { defaultTheme } from '../../../../../../utils/defaultTheme';

export const HorizontalGroupedChartWrapper = styled.div`
    background: ${defaultTheme.grey[50]};
    border: 1px dashed ${defaultTheme.blue[900]};
    display: flex;
`;
export const HorizontalGroupedChartSvg = styled.svg``;
